<br>
<div>
    <div class="textBlock">
        <div>
            <p class="h2 text-center">Halte 2</p>
            <hr>
        </div>
        <div>
            <div class="text-center">
                <p class="h4 text-center">
                    Navigatie
                </p>
                <hr>
                <p class="text-center d-block margin">
                    Volg de Zeurtebaan tot je aan de linkerkant aan de Gagelbaan komt. Die ga je niet in, maar je kiest voor het bospaadje naar rechts. Je slaat daar meteen linksaf. Volg de weg tot je aan sportpark De Zeurt komt. Volg het grindpad rechtdoor.              
                </p>
                <hr>
                <p class="h4 text-center">
                    Waar denk jij aan?
                </p>
                <hr>
                <p class="text-center d-block margin">
                    Wat is trouwens je favoriete chiroliedje? Ken je nog kampliedjes? Waarom zingen jullie er geen tijdens de wandeling? Zing het laatste kampliedje dat je je herinnert.             
                </p>
                <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/3/35/Simple_Music.svg/600px-Simple_Music.svg.png" alt="Muzieknoot.png">
            </div>
            <hr class="afterImage">
            <p class="h4 text-center">
                Navigatie
            </p>
            <hr>
            <p class="text-center d-block margin">
                Zingend kom je bij de parking van sportpark De Zeurt.             
            </p>
        </div>
        
    </div>
    <div class="text-center buttonMargin">
        <button type="button" class="btn btn-primary" [routerLink]="'/halte3'">Volgende stop</button>
    </div>
</div>